module.exports = __webpack_public_path__ + "img/CellCycle-LUCA_10X_LU.0f480a79.png";